import { useEffect } from "react";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import ProvidingInclusiveKindergartenEnvironmentComponent from "../../components/applicationComponents/providingInclusiveKindergartenEnvironment/ProvidingInclusiveKindergartenEnvironmentComponent";

export default function ProvidingInclusiveKindergartenEnvironmentPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Providing an inclusive Kindergarten Environment",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <ProvidingInclusiveKindergartenEnvironmentComponent disabled={false} />
    </>
  );
}
